import useCustomer from '@lib/hooks/useCustomer'
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import { useEffect } from 'react'
import { useInstantSearch } from 'react-instantsearch'
import aa from 'search-insights'

export default function InsightsMiddleware(locale: any) {
  const { addMiddlewares } = useInstantSearch()
  const { customer, loading } = useCustomer()
  useEffect(() => {
    if (!loading) {
      const middleware = createInsightsMiddleware({
        insightsClient: aa,
        insightsInitParams: {
          useCookie: true,
        } as any,
      })
      const customerId = customer?.id
      const customerIdParts = customerId?.split('/')
      const customerIdDigiPart = customerIdParts?.[customerIdParts.length - 1]
      const userToken = customerIdDigiPart
        ? `shopify-customer-${customerIdDigiPart}`
        : ''
      aa('setUserToken', userToken)
      return addMiddlewares(middleware)
    }
    return undefined
  }, [addMiddlewares, customer?.id, loading, locale])
  return null
}
